<template>
  <v-footer dark padless>
    <v-card class="flex" flat tile>
      <v-card-title class="red">
        <strong class="subheading"
          >Get connected with us on social!</strong
        >

        <v-spacer></v-spacer>
        <a
          class="footer-link"
          v-for="sm in socialMedia"
          :key="sm.icon"
          :href="sm.link"
          target="_blank"
        >
          <v-btn class="mx-4" dark icon>
            <v-icon size="24px">{{ sm.icon }}</v-icon>
          </v-btn>
        </a>
      </v-card-title>

      <v-card-text class="py-2 white--text text-center">
        {{ new Date().getFullYear() }} — <strong>Diligent Dev</strong>
      </v-card-text>
    </v-card>
  </v-footer>
</template>

<script>
export default {
  data: () => ({
    socialMedia: [
      {
        icon: "fab fa-facebook",
        link: "https://www.facebook.com/TheDiligentDev"
      },
      {
        icon: "fab fa-twitter",
        link: "https://twitter.com/TheDiligentDev"
      }
      //   "fab fa-google-plus",
      //   "fab fa-linkedin",
      //   "fab fa-instagram"
    ]
  })
};
</script>

<style scoped>
.footer-link {
  color: transparent !important;
  cursor: pointer !important;
}
</style>
